import * as React from 'react';
import { Typography as MuiTypography, Paper as MuiPaper } from '@material-ui/core';
import styled from 'styled-components';
import { spacing } from '@material-ui/system';

interface Props {
  summaryMessage: string;
  additionalMessage?: string;
}

const InvoiceDetailMessage = ({ summaryMessage, additionalMessage }: Props) => {
  return (
    <InvoiceSummaryDescriptionBlock>
      <Typography variant={'subtitle1'} mb={2}>
        Invoice Message
      </Typography>
      <Paper p={3}>
        <Description mb={1}>{summaryMessage}</Description>
        {additionalMessage && <Description>{additionalMessage}</Description>}
      </Paper>
    </InvoiceSummaryDescriptionBlock>
  );
};

export default InvoiceDetailMessage;

const Paper = styled(MuiPaper)(spacing);
export const Typography = styled(MuiTypography)(spacing);
const Description = styled.div(spacing);

const InvoiceSummaryDescriptionBlock = styled.div`
  margin-top: ${props => props.theme.spacing(2)}px;
  margin-bottom: ${props => props.theme.spacing(5)}px;
`;
